/*
 * COPYRIGHT (c) 2023
 * HONEYWELL INC.,
 * ALL RIGHTS RESERVED
 *
 * This software is a copyrighted work and/or information protected as a trade secret.
 * Legal rights of Honeywell Inc. in this software is distinct from ownership of any medium
 * in which the software is embodied. Copyright or trade secret notices included must be
 * reproduced in any copies authorized by Honeywell Inc.
 *
 */

import { useEffect, useState } from 'react';
import {
  IAccount,
  IAny
} from '../../../DashboardKPIWidgets/IEnergyManagementProps';

const useFilter = (props: IAny) => {
  const [isOpen, setIsOpen] = useState(false);
  const [data, setData] = useState(JSON.parse(JSON.stringify(props.data)));
  const [originalData, setOriginalData] = useState(props.data);

  useEffect(() => {
    setOriginalData(props.data);
    setTimeout(() => {
      setData(props.data);
    }, 100);
  }, [props.data]);

  useEffect(() => {
    if (originalData && originalData.length) {
      const tempOriginalData = JSON.parse(JSON.stringify(originalData));
      setOriginalData(
        tempOriginalData.map((dt: IAny) => {
          const selectedAccn = data.filter(
            (item: IAny) => item.accountNumber === dt.accountNumber
          );
          if (selectedAccn.length > 0) {
            dt.isSelected = selectedAccn[0].isSelected;
          }
          return dt;
        })
      );
    }
  }, [data]);

  const hidePopup = () => {
    setIsOpen(false);
  };

  const handleOpen = () => {
    setIsOpen(true);
  };

  const applyOnClick = () => {
    props.onApply(originalData);
    hidePopup();
  };

  const applyOnClickSelected = () => {
    const appliedData = originalData.filter(
      (element: IAny) => element.isSelected
    );
    const finalAccounts = appliedData.map((el: IAccount) => el.accountNumber);
    props.onApply(finalAccounts);
    hidePopup();
  };

  const cancelOnClick = () => {
    setData(props.data);
    hidePopup();
  };

  const onCheckboxClick = (checked: boolean, element: IAny, field: string) => {
    setData((prev: IAny) =>
      prev.map((item: IAny) =>
        item[field] === element[field] ? { ...item, isSelected: checked } : item
      )
    );
  };

  const onSelectAll = (checked: boolean) => {
    setData(data.map((item: IAny) => ({ ...item, isSelected: checked })));
  };

  const onSearch = (searchText: string) => {
    // const tempData = searchText ? JSON.parse(JSON.stringify(data)) : JSON.parse(JSON.stringify(originalData));
    const tempData = JSON.parse(JSON.stringify(originalData));
    const dataWithSelectUnselect = tempData.map((dt: IAny) => {
      const selectedAccn = data.filter(
        (item: IAny) => item.accountNumber === dt.accountNumber
      );
      if (selectedAccn && selectedAccn.length > 0) {
        dt.isSelected = selectedAccn[0].isSelected;
      }
      return dt;
    });
    if (searchText) {
      setData(
        dataWithSelectUnselect.filter((item: IAny) =>
          item.accountNumber.includes(searchText)
        )
      );
    } else {
      setData(dataWithSelectUnselect);
    }
    // setData(originalData.filter((item: IAny) => item.accountNumber.includes(searchText)))
  };

  return {
    isOpen,
    data,
    onCheckboxClick,
    hidePopup,
    handleOpen,
    applyOnClick,
    cancelOnClick,
    onSearch,
    onSelectAll,
    applyOnClickSelected
  };
};

export default useFilter;
